import PropTypes from 'prop-types';

import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';

export const ConfigLinksDefaultProps = {
  ...ClassNameDefaultProps,
  configurations: [],
  bundleParents: [],
  isBundle: false,
  title: '',
};

export const ConfigLinksPropTypes = {
  ...ClassNamePropTypes,
  configurations: PropTypes.arrayOf(PropTypes.shape({})),
  bundleParents: PropTypes.arrayOf(PropTypes.shape({})),
  isBundle: PropTypes.bool,
  title: PropTypes.string,
};
